import { useState, useEffect } from "react";
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { useMsal } from "@azure/msal-react";
import { PageTitle } from "./PageTitle";
import { CircularProgress,Backdrop } from '@material-ui/core';

export const ReportList = () => {
	const { instance, accounts } = useMsal();
	const [reports, setReports] = useState([])
	const [columns, setColumns] = useState([]);
	const [downloading, setDownloading] = useState(false);

	function requestAgriadaptToken() {
		// Silently acquires an access token which is then attached to a request for Agriadapt API
		const loginRequest = {
			scopes: ["api://50e457bf-ecab-45c0-8fa5-e2bf19675f5a/Agriadapt.Contributors"]
		};
		instance.acquireTokenSilent({
			...loginRequest,
			account: accounts[0]
		}).then((response) => {
			sessionStorage.setItem("agriadaptToken", response.accessToken);
			getReports();
		});
	}


	useEffect(() => {
		setColumns([
			{ field: 'projectName', headerName: 'Project Name', flex: 2 },
			{ field: 'clientName', headerName: 'Client Name', flex: 2 },
			{ field: 'emailAddress', headerName: 'email', flex: 1 },
			{
				field: 'startDate', headerName: 'Started at',
				type: 'date',
				valuGetter: ({ value }) => value && new Date(value).toLocaleString(),
				description: 'This column has a value getter and is not sortable.', flex: 1
			},
			{
				field: 'reportZipUrl', headerName: 'Report', description: 'This column has a value getter and is not sortable.', flex: 1,
				renderCell: (params) => (
					//params.value ? <a href={"https://sanptidbinvestagriadapt.blob.core.windows.net/agriadaptcontainer"+params.value}>Download</a> : <a href="#" onClick={(event) => { getReportOutput(params.id) }}>Get Report</a>
					params.value ? <a href="#" onClick={(event) =>{handleDownload(params.value)}}>Download</a> : <a href="#" onClick={(event) => { getReportOutput(params.id) }}>Get Report</a>
				)
			},
		]);
		requestAgriadaptToken();
	}, []);

	const getReports = () => {
		let config = {
			method: 'get',
			url: "https://idbinvestapi-t.iadb.org/agriadapt/Report",
			headers: { 
				'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
				'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`,//PROD
				'Ocp-Apim-Trace':'true'
			}
		}; 
		axios(config).then(res => {
			const reports = res.data;
			setReports(reports);
		});
	};



	const handleDownload = (blobName) => {
		setDownloading(true);
		let config = {
			method: 'get',
			url: "https://idbinvestapi-t.iadb.org/agriadapt/Report/download",
			headers: { 
			  'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
			  'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`,//PROD
			  'Ocp-Apim-Trace':'true',
			  'Content-Type': 'application/zip',
			  'Response-Type': 'arraybuffer',
			  'Accept': 'application/zip',
			},
			responseType: 'arraybuffer',
			params: {
			  blobName: blobName
			},
			maxBodyLength: Infinity,

		  };

		axios(config).then((response) => {
			const filename = getFilenameFromResponseHeader(response.headers['content-disposition']);
			const blob = new Blob([response.data], { type: 'application/zip' });
  			const url = window.URL.createObjectURL(blob);
  			const link = document.createElement('a');
  			link.href = url;
			link.setAttribute('download', filename);
  			document.body.appendChild(link);
  			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
			setDownloading(false);
  			return "OK";
			
		});
	  }

	  function getFilenameFromResponseHeader(header) {
		const matches = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
		if (matches) {
		  let filename = matches[1].replace(/['"]/g, '');
		  const lastSlashIndex = filename.lastIndexOf('/');
		  if (lastSlashIndex !== -1) {
			filename = filename.substring(lastSlashIndex + 1);
		  }
		  return filename;
		} else {
		  return 'unknown';
		}
	  }

	const getReportOutput = (id) => {
		let config = {
			method: 'get',
			url: "https://idbinvestapi-t.iadb.org/agriadapt/Report/getReportOutput?reportId=" + id,
			headers: { 
				'Authorization': `Bearer ${sessionStorage.getItem("agriadaptToken")}`,
				'Ocp-Apim-Subscription-Key': `f497a6c30797423b9c4794d3f70c0ad7`,//TEST
				//'Ocp-Apim-Subscription-Key': `ab404da35c6649619e6b748af1765a7e`,//PROD
				'Ocp-Apim-Trace':'true'
			}
		}; 
		axios(config).then(res => {
			console.log(res);
			getReports();
			if (res.data.reportZipUrl) {
				getReports();
			}
			else {
				alert("Report is pending, please wait");
			}
		});
	}
	return (
		<>
			<PageTitle title="Reports" />
				<div style={{ width: '100%', height: '100%' }}>
				<Backdrop open={downloading} style={{ zIndex: 999 }}>
					<CircularProgress color="inherit" />
				</Backdrop>
				<DataGrid autoHeight
					rows={reports}
					columns={columns}
					pageSize={10}
					rowsPerPageOptions={[10]}
				/>
			</div>
		</>
	)
}